import __base_store from '@/store/__base_store'

/**
 * Store de grupos de tipo de precio de artículos (modelo `article_price_type_group`).
 * Construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo. */
	state: {
		model_name: 'article_price_type_group',
	},
})

